// components/CategoryNav.jsx - 分类导航组件
import React from 'react';
import './CategoryNav.css';

const CategoryNav = ({ categories, selectedCategory, onSelectCategory }) => {
  return (
    <nav className="category-nav" aria-label="Categories">
      <div className="nav-container">
        <ul className="category-list" role="tablist" aria-label="Category tabs">
          {categories.map(category => (
            <li key={category.id} className="category-item">
              <button 
                className={`category-btn ${selectedCategory === category.id ? 'active' : ''}`}
                onClick={() => onSelectCategory(category.id)}
                role="tab"
                aria-selected={selectedCategory === category.id}
                aria-current={selectedCategory === category.id ? 'page' : undefined}
              >
                {category.name}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default CategoryNav;
